// extracted by mini-css-extract-plugin
export default {"label":"SurveyTextQuestion_label__fXl00","textArea":"SurveyTextQuestion_textArea__PwG2e","regExpLabel":"SurveyTextQuestion_regExpLabel__XUUb1"};